// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__12jyQ","disabled":"FileBtn_disabled__3mM9v","warn":"FileBtn_warn__1BPso","fade":"FileBtn_fade__37Zrl"};